import React from 'react';

import './search-box.style.scss';

export const SearchBox = ({ placeholder, handleChange }) => (
    <div>
    <input className="search" type="search" placeholder={placeholder} onChange={handleChange} />
    <br/>
    <a href="https://comparateur.choisirmongroupement.com">
        <button className="button">
            <div className="button1">Comparer les différentes solutions</div>
            <div className="button2">Gratuit et sans engagement</div>
        </button>
    </a>
    </div>
)